<template>
  <div class="case-manage-container main-manage-list-container recommend-Case-container">
    <el-form
      class="case__filter-container manage-list__filter-container"
      ref="caseSearchForm"
      :model="form"
    >
      <el-form-item>
        <el-input v-model="form.search" placeholder="案例名称" maxLength="20"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="form.mold_id" @change="getLists" placeholder="分类">
          <el-option
            v-for="(option) in moldChildren"
            :key="option.id"
            :label="option.name"
            :value="option.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button style="margin: 0 10px;" @click="getLists">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <cases
      class="case__main-body manage-list__main-body"
      theme="manage"
      :cases="lists"
      :isShowPagination="paginationConfig"
      @onDelete="del"
    ></cases>
  </div>
</template>

<script>
import Cases from '@/pages/case/_list.vue';
import { myList, deleteCase } from '@/api/case';
import { userDel, molds } from '@/api/common';
import { lists as caseList } from '@/api/case';

export default {
  components: {
    Cases,
  },
  data() {
    return {
      form: {
        // status: '',
      },
      lists: [],
      pageSize: 15,
      paginationConfig: null,
      moldChildren: [],
    };
  },
  computed: {
    status() {
      return this.$route.query.status || '3';
    },
    page() {
      return this.$route.query.page || 1;
    },
  },
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
  },
  created() {
    molds(this.moldId).then(res => {
      this.moldChildren = res.data.list;
    });
  },
  methods: {
    init() {
      this.form.status = this.status;
      // 获取数据
      this.getLists();
    },
    async getLists() {
      // 获取数据
      this.$store.commit('openLoading');
      const res = await caseList({
      // const res = await myList({
        page: this.page,
        page_size: this.pageSize,
        is_recommend: 2,
        search: this.form.search,
        mold_id: this.form.mold_id || null,
        store_type: 4, //推荐案例
      });
      const { data } = res;
      this.lists = data.list;
      this.paginationConfig = data.total;
      this.$store.commit('closeLoading');
    },
    reset() {
      this.form = {}
      this.init()
    },
    del(id) {
      const that = this;
      userDel('确定删除该案例？', () => deleteCase({ id }), () => {
        that.lists = that.lists.filter((item) => Number(item.id) !== Number(id));
      });
    },
  },
};
</script>

<style lang="scss">
  .recommend-Case-container {
    .mangeHover {
      &:hover {
        .item__manage {
          display: none !important;
        }
      }
    }
    .item__manage-status {
      display: none !important;
    }
    .el-input {
      padding-top: 0 !important;
    }
  }
</style>
